import React, {ReactNode} from "react";
import {useMaintenanceModeStore} from "store/general/maintenanceMode.store";
import MaintenanceMode from "view/apps/MaintenanceMode";

/**
 * Shows the maintenance page instead of `children` while maintenance mode is
 * on. For public pages that write through api-v2 (the embedded show list /
 * exhibitor sign-up widget): they render outside the role router, so its
 * maintenance check never reaches them, and api-v2 itself has no maintenance
 * switch — the Firebase callables they replaced refused writes here.
 */
const MaintenanceModeGate = ({children}: {children: ReactNode}) => {
  const isEnabled = useMaintenanceModeStore(
    (state) => !!state.maintenanceMode?.enabled
  );

  if (isEnabled) {
    return <MaintenanceMode />;
  }

  return <>{children}</>;
};

export default MaintenanceModeGate;
